import React, { FunctionComponent } from 'react';
import styles from './styles.module.scss';

interface Props {
  error?: string | null;
}

export const LoginError: FunctionComponent<Props> = ({ error }) => {
  const hasErrorProp = !!error;
  if (!hasErrorProp) {
    return null;
  }

  return <div className={styles.loginError}>{error}</div>;
};
